import React from 'react';
import { Input, InputProps } from 'reactstrap';

export const BaseInput: React.FC<InputProps> = (props) => (
  <Input {...props}></Input>
);